const DASHBOARD_PROFILE = localStorage.getItem('dashboard_profile')
const DASHBOARD_EXPIRE = localStorage.getItem('dashboard_expire')
const DASHBOARD_ACCESSTOKEN = localStorage.getItem('dashboard_access_token')

exports.validateAdmin = () => {
  if (DASHBOARD_PROFILE.includes('admin')){
    return true
  } 
  return false
}

exports.validateSession = () => {
  if (!DASHBOARD_EXPIRE || DASHBOARD_EXPIRE < Date.now() || !DASHBOARD_ACCESSTOKEN){
    console.log('Sesión expirada')
    return false
  } 
  return true
}